import { apiClient } from './api'

export interface Harvest {
  id: string
  yardId: string | number
  harvestDate: string
  honeyType?: string
  format?: string
  quantity?: number
  notes?: string
  createdAt?: string
}

export interface CreateHarvestPayload {
  yardId: string | number
  harvestDate: string
  honeyType?: string
  format?: string
  quantity?: number
  notes?: string
  userId?: string | number
}

/**
 * Gets harvests
 * @param params - Query params
 * @returns Promise with harvest list
 */
export function getHarvests(params?: { yardId?: string | number }) {
  return apiClient.get<Harvest[]>('/harvests', { params })
}

/**
 * Creates a new harvest
 * @param payload - Harvest payload
 * @returns Promise with harvest
 */
export function createHarvest(payload: CreateHarvestPayload) {
  return apiClient.post<Harvest>('/harvests', payload)
}
